import { useEffect } from 'react';
import { jivoWidgetId } from '@/config/publicEnv';

/**
 * Подключает скрипт виджета Jivo только на лендинге.
 * Пустой VITE_JIVO_WIDGET_ID — скрипт не вставлять (dev без виджета).
 */
export function JivoWidget() {
  useEffect(() => {
    const id = jivoWidgetId;
    if (!id) {
      return undefined;
    }
    const script = document.createElement('script');
    script.src = `//code.jivo.ru/widget/${id}`;
    script.async = true;
    script.dataset.jivoWidget = 'true';
    document.head.appendChild(script);
    return () => {
      script.remove();
    };
  }, []);
  return null;
}
